var app = angular.module('leonardo');

var LabelRequiredDirective = function(ConfigThemeService, $timeout) {
  return {
    restrict: 'C',
    scope: {
      requiredColor: '@',
      ngClass: '=?'
    },
    link: function (scope, element) {

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          var color = scope.requiredColor ? ConfigThemeService.getColor(scope.requiredColor) : ConfigThemeService.config.theme_config.errorColor;
          if (element.find('.after').length === 0){
            var after = angular.element( "<span class='after'>*</span>" );
            after.css('color', color);
            element.append( after );
          }
        });
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('labelRequired', ['ConfigThemeService', '$timeout', LabelRequiredDirective]);
